import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  TextField,
  Divider,
  InputLabel,
  Select,
  FormControl,
  Box,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import { ExitToApp } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import GeneralData from "../../../../data/GeneralData.js";

const EditColorMotos = ({
  showModal,
  setShowMondal,
  handleClick,
  listcolor,
  motojson,
}) => {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [initialValue, setInitialValue] = React.useState(showModal?.data);

  const [selectedImage, setSelectedImage] = useState({
    smallimage: null,
    hugeimage: null,
  });

  const [imageUrl, setImageUrl] = useState({
    url_small:
      GeneralData.host + initialValue?.url_foto_color_peque,
    url_huge:
      GeneralData.host + initialValue?.url_foto_color_grande,
  });

  useEffect(() => {
    if (selectedImage.smallimage) {
      setImageUrl((prevState) => ({
        ...prevState,
        url_small: URL.createObjectURL(selectedImage.smallimage),
      }));
    }
    if (selectedImage.hugeimage) {
      setImageUrl((prevState) => ({
        ...prevState,
        url_huge: URL.createObjectURL(selectedImage.hugeimage),
      }));
    }
  }, [selectedImage]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    if (e.target.name === "url_foto_color_peque") {
      setSelectedImage((prevState) => ({
        ...prevState,
        smallimage: e.target.files[0],
      }));
    }
    if (e.target.name === "url_foto_color_grande") {
      setSelectedImage((prevState) => ({
        ...prevState,
        hugeimage: e.target.files[0],
      }));
    }
    setInitialValue((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeColors = (e) => {
    const { value } = e.target;
    let id_color;
    for (let i = 0; i < listcolor.length; i++) {
      if (listcolor[i].nombre_color === value) {
        id_color = listcolor[i].id;
      }
    }
    setInitialValue((prevState) => ({
      ...prevState,
      colore: {
        ...prevState?.colore,
        nombre_color: value ?? "",
        id_color: id_color,
        id_moto: motojson.id,
      },
    }));
  };

  return (
    <Dialog
      open={showModal?.show}
      keepMounted
      onClose={ExitModal}
      fullWidth
      maxWidth="xs"
    >
      <Typography
        style={{ fontSize: "28px", margin: "16px 24px" }}
        variant="h1"
        gutterBottom
      >
        {showModal?.data
          ? `Editar color para ${motojson.nombre}`
          : `Agregar color para ${motojson.nombre}`}
      </Typography>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FormControl style={{ width: 397 }}>
              <InputLabel id="Color"> Color </InputLabel>
              <Select
                name="nombre_color"
                value={initialValue?.colore?.nombre_color}
                onChange={handleChangeColors}
                input={<OutlinedInput label="Color" />}
                MenuProps={MenuProps}
              >
                {listcolor?.map((item) => (
                  <MenuItem key={item?.id} value={item?.nombre_color}>
                    {item?.nombre_color}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            {/* Imagen pequeña */}
            <TextField
              accept="image/*"
              type="file"
              id="select-image"
              style={{ display: "none" }}
              name="url_foto_color_peque"
              onChange={handleChange}
            />
            <label htmlFor="select-image">
              <Button
                variant="contained"
                color="primary"
                component="span"
                fullWidth
                style={{ height: 45 }}
              >
                <p style={{ fontSize: 14 }}> Cargar imagen pequeña </p>
              </Button>
            </label>
            <Box mt={2} mb={2} textAlign="center">
              {showModal?.data || initialValue?.url_foto_color_peque ? (
                <span style={{ height: 55, width: 55 }}>
                  Tamaño de la imagen recomendado:{" "}
                  <span style={{ color: "blue" }}> 720 x 500 px </span>
                  <img
                    src={imageUrl.url_small}
                    alt="foto_url_pequeña"
                    style={{ paddingTop: 8, height: 50, width: 70 }}
                  />
                </span>
              ) : (
                <></>
              )}
            </Box>
            {/* Imagen grande */}
            <TextField
              accept="image/*"
              type="file"
              id="select-image2"
              style={{ display: "none" }}
              name="url_foto_color_grande"
              onChange={handleChange}
            />
            <label htmlFor="select-image2">
              <Button
                variant="contained"
                color="primary"
                component="span"
                fullWidth
                style={{ height: 45 }}
              >
                <p style={{ fontSize: 14 }}> Cargar imagen Grande </p>
              </Button>
            </label>
            <Box mt={2} textAlign="center">
              {showModal?.data || initialValue?.url_foto_color_grande ? (
                <span style={{ height: 55, width: 55 }}>
                  Tamaño de la imagen recomendado:
                  <span style={{ color: "blue" }}> 1800 x 1250 px </span>
                  <img
                    src={imageUrl.url_huge}
                    alt="foto_url_pequeña"
                    style={{ paddingTop: 8, height: 50, width: 70 }}
                  />
                </span>
              ) : (
                <></>
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <Divider style={{ marginBottom: "10px" }} />
      <DialogActions>
        <Button
          size="medium"
          variant="contained"
          style={{ height: 40 }}
          onClick={() => {
            if (initialValue) {
              handleClick(initialValue, selectedImage);
            }
          }}
        >
          <SaveIcon style={{ fontSize: 25 }} />
        </Button>
        <Button
          size="medium"
          variant="contained"
          color="error"
          onClick={ExitModal}
          style={{ height: 40 }}
        >
          <ExitToApp style={{ fontSize: 25 }} />
        </Button>
      </DialogActions>
    </Dialog>
  );

  function ExitModal(e) {
    setShowMondal({
      show: false,
      data: {},
    });
  }
};

export default EditColorMotos;
